import { render, staticRenderFns } from "./PrescriptionTemp.vue?vue&type=template&id=25090c1d&scoped=true"
import script from "./PrescriptionTemp.vue?vue&type=script&lang=js"
export * from "./PrescriptionTemp.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionTemp.vue?vue&type=style&index=0&id=25090c1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25090c1d",
  null
  
)

export default component.exports